<template>
  <div id="contenedor">
    <v-layout row wrap="">
      <v-flex xs12 sm12 md12>
        <v-card
          class="table"
          elevation="0"
          style="border-radius: 16px; border: 1px solid #e5e7eb"
        >
          
          <v-toolbar flat elevation="0" style="padding: 0 24px" height="100">
            <v-btn
              style="
                background: #1e3a8a;
                color: white;
                border-radius: 16px;
                width: 80px;
                height: 80px;
                box-shadow: 0 4px 15px rgba(30, 58, 138, 0.3);
                border: 1px solid rgba(255, 255, 255, 0.1);
              "
            >
              <v-icon>mdi-home</v-icon>
            </v-btn>
            <div
              class="text-h5 font-weight-bold"
              style="color: black; margin-left: 16px"
            >
              Historial de Movimientos
            </div>

            <v-spacer></v-spacer>

            <!-- Botón para abrir modal -->
            <v-dialog v-model="dialog" max-width="700px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  class="botonplus"
                  v-on="on"
                  style="
                    background: #1e3a8a;
                    color: white;
                    border-radius: 12px;
                    margin-right: 16px;
                  "
                >
                  <v-icon color="white">mdi-plus-thick</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-card-title
                  class="nav"
                  style="background: #1e3a8a; color: white"
                >
                  <span class="headline"
                    ><v-icon color="white">mdi-home</v-icon>
                    {{ formTitle }}</span
                  >
                </v-card-title>

                <!-- FORMULARIO COMPLETO -->
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm8 md8>
                        <br />
                        <v-subheader>Tipo de movimiento</v-subheader>
                      </v-flex>

                      <v-flex xs12 sm4 md4>
                        <v-radio-group v-model="editedItem.movimiento">
                          <v-radio label="Entrada" value="entrada"></v-radio>
                          <v-radio label="Salida" value="salida"></v-radio>
                        </v-radio-group>
                      </v-flex>

                      <!-- Cambiado de v-autocomplete a v-combobox para que no se borre el valor -->
                      <v-flex xs12 sm12 md12>
                   <v-combobox
                      v-model="editedItem.activofijo"
                      :items="permisosActivos"
                      item-text="activo_fijo"
                      item-value="activo_fijo"
                      label="Activo fijo"
                      :search-input.sync="searchActivoFijo"
                      :loading="loadingActivoFijo"
                      
                      @input="onActivoFijoDesdeLista"
                      @change="onEnterActivoFijo"
                      clearable
                    >

                          <template v-slot:item="{ item }">
                            <v-list-item-content  >
                              <v-list-item-title>{{
                                item.activo_fijo
                              }}</v-list-item-title>
                              <v-list-item-subtitle>
                                <v-chip
                                  x-small
                                  :color="
                                    item.permiso === 'SI' ? 'green' : 'red'
                                  "
                                  dark
                                >
                                  {{
                                    item.permiso === "SI"
                                      ? "Autorizado"
                                      : "No autorizado"
                                  }}
                                </v-chip>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-combobox>
                      </v-flex>

                      <v-flex xs12 sm12 md12 v-if="permisoEstado !== null">
                        <v-alert
                          v-if="permisoEstado === true"
                          type="success"
                          outlined
                          dense
                          color="green"
                        >
                          {{ permisoMensaje }}
                        </v-alert>

                        <v-alert
                          v-else-if="permisoEstado === false"
                          type="error"
                          outlined
                          dense
                          color="red"
                        >
                          {{ permisoMensaje }}
                        </v-alert>

                        <v-alert
                          v-else-if="permisoEstado === 'notfound'"
                          type="warning"
                          outlined
                          dense
                          color="yellow darken-2"
                        >
                          {{ permisoMensaje }}
                        </v-alert>
                      </v-flex>

                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.dispositivo"
                          label="Tipo dispositivo"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.marca"
                          label="Marca"
                        ></v-text-field>
                      </v-flex>

                      <!-- Agregado v-flex para contener el v-combobox correctamente -->
                      <v-flex xs12>
                        <v-combobox
                          v-model="editedItem.cargo"
                          :items="listaCargos"
                          item-text="nombreCargo"
                          item-value="nombreCargo"
                          :search-input.sync="searchCargo"
                          label="Cargo"
                          placeholder="Buscar o escribir cargo..."
                          clearable
                        />
                      </v-flex>

                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.nombreMovimiento"
                          label="Nombre"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <!-- BOTONES -->
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1D3C7F" @click="close">Cancelar</v-btn>
                  <v-btn
                    color="#1D3C7F"
                    @click="save"
                    :disabled="!editedItem.cargo"
                  >
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Botón exportar original -->
            <v-btn
              style="
                background: linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%);
                color: white;
                border-radius: 12px;
                padding: 0 24px;
              "
              @click="downloadExcel"
            >
              <v-icon left>mdi-file-excel</v-icon>
              Exportar
            </v-btn>
          </v-toolbar>


          <div
            class="pa-6"
            style="background-color: #f9fafb; border-bottom: 1px solid #e5e7eb"
          >
            <v-row align="center" no-gutters>
              <v-col cols="12" md="4" class="px-2">
                <v-text-field
                  v-model="search"
                  label="Buscar..."
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  dense
                  hide-details
                  clearable
                  style="background-color: white; border-radius: 8px"
                  @input="aplicarFiltros"
                ></v-text-field>
              </v-col>

              <!-- Filtro de tipo de movimiento -->
              <v-col cols="12" md="3" class="px-2">
                <v-select
                  v-model="tipoMovimiento"
                  :items="[
                    { text: 'Todos', value: '' },
                    { text: 'Entrada', value: 'entrada' },
                    { text: 'Salida', value: 'salida' },
                  ]"
                  label="Tipo de movimiento"
                  outlined
                  dense
                  hide-details
                  style="background-color: white; border-radius: 8px"
                  @change="aplicarFiltros"
                ></v-select>
              </v-col>

              <!-- Buscador general -->
              <v-col cols="12" md="4" class="px-2">
                <v-menu
                  ref="menuRango"
                  v-model="menuRango"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="rangoTexto"
                      label="Rango de fechas"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      hide-details
                      style="background-color: white; border-radius: 8px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="dates"
                    range
                    scrollable
                    @input="onDatesInput"
                    @change="guardarFechas"
                  />
                </v-menu>
              </v-col>

              <v-col cols="12" md="1" class="pl-2">
                <v-btn
                  icon
                  @click="limpiarFiltros"
                  style="
                    background: linear-gradient(
                      135deg,
                      #ef4444 0%,
                      #dc2626 100%
                    );
                    color: white;
                    border-radius: 12px;
                    width: 40px;
                    height: 40px;
                    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
                  "
                  title="Limpiar filtros"
                >
                  <v-icon>mdi-filter-remove</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>


          <v-data-table
            :items="areas"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            :loading="loading"
            @update:page="obtenerTodo"
            class="elevation-0"
            style="border-radius: 0 0 16px 16px"
            hide-default-footer
          >
            <template v-slot:no-data>
              <div class="pa-8 text-center">
                <v-icon size="48" color="grey lighten-1"
                  >mdi-database-search</v-icon
                >
                <div class="text-h6 grey--text text--lighten-1 mt-4">
                  No se encontraron registros
                </div>
              </div>
            </template>

            <!-- Headers con mejor estilo -->
            <template v-slot:header>
              <thead>
                <tr
                  style="
                    background-color: #f8fafc;
                    border-bottom: 2px solid #e5e7eb;
                  "
                >
                  <th
                    v-for="header in headers"
                    :key="header.text"
                    class="text-subtitle-2 font-weight-bold grey--text text--darken-2 pa-4"
                    style="
                      text-transform: uppercase;
                      letter-spacing: 0.5px;
                      font-size: 12px !important;
                    "
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </thead>
            </template>

            <!-- Filas con mejor espaciado y hover -->
            <template v-slot:item="{ item }">
              <tr style="border-bottom: 1px solid #f1f5f9" class="hover-row">
                <td class="pa-4">
                  <v-chip
                    small
                    style="
                      background-color: #dbeafe;
                      color: #1e40af;
                      font-weight: 600;
                      border-radius: 6px;
                    "
                  >
                    {{ item.sede || "ADMINISTRATIVA" }}
                  </v-chip>
                </td>
                <td class="pa-4 text-body-2 font-weight-medium">
                  {{ item.dispositivo }}
                </td>
                <td class="pa-4 text-body-2">{{ item.fechaMovimiento }}</td>
                <td class="pa-4 text-body-2 font-weight-medium">
                  {{ item.activofijo || item.serial }}
                </td>
                <td class="pa-4 text-body-2">{{ item.nombreMovimiento }}</td>
                <!-- Mostrar cargo en lugar de modelo -->
                <td class="pa-4 text-body-2">
                  {{ item.cargo || item.modelo }}
                </td>
                <td class="pa-4 text-body-2">
                  {{ item.vigilante_nombre || item.idVigilante }}
                </td>
                <td class="pa-4">
                  <v-chip
                    small
                    :style="
                      item.movimiento === 'entrada'
                        ? 'background-color: #d1fae5; color: #065f46;'
                        : 'background-color: #fee2e2; color: #991b1b;'
                    "
                  >
                    {{
                      item.movimiento
                        ? item.movimiento.toUpperCase()
                        : "ENTRADA"
                    }}
                  </v-chip>
                </td>
                <td class="pa-4 text-center">
                  <v-btn
                    icon
                    small
                    @click="editItem(item)"
                    style="transition: all 0.3s ease"
                    class="edit-btn"
                  >
                    <v-icon size="18">mdi-pencil</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>

            <!-- Footer más limpio -->
            <template v-slot:footer>
              <div
                class="d-flex justify-space-between align-center pa-4"
                style="background-color: #f8fafc; border-top: 1px solid #e5e7eb"
              >
                <span
                  class="text-caption"
                  style="color: #495057; font-weight: 500"
                >
                  Mostrando {{ (page - 1) * itemsPerPage + 1 }}-{{
                    Math.min(page * itemsPerPage, totalItems)
                  }}
                  de {{ totalItems }} registros
                </span>
                <div class="d-flex align-center">
                  <v-btn
                    icon
                    small
                    :disabled="page === 1"
                    @click="page-- || obtenerTodo()"
                  >
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                  <span class="text-body-2 mx-3">{{ page }}</span>
                  <v-btn
                    icon
                    small
                    :disabled="page * itemsPerPage >= totalItems"
                    @click="page++ || obtenerTodo()"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Agregado snackbar que estaba faltando -->
    <v-snackbar v-model="snackbar" :timeout="3000" top color="success">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import env from "../../env";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      areas: [],
      activos: [],
      searchActivo: "",
      headers: [
        { text: "SEDE", value: "sede", align: "center" },
        { text: "DISPOSITIVO", value: "dispositivo", align: "center" },
        { text: "FECHA MOVIMIENTO", value: "fechaMovimiento", align: "center" },
        { text: "ACTIVO FIJO", value: "activofijo", align: "center" },
        { text: "RESPONSABLE", value: "nombreMovimiento", align: "center" },
        { text: "CARGO", value: "cargo", align: "center" },
        { text: "VIGILANTE", value: "vigilante_nombre", align: "center" },
        { text: "TIPO MOVIMIENTO", value: "movimiento", align: "center" },
        {
          text: "ACCIONES",
          value: "acciones",
          align: "center",
          sortable: false,
        },
      ],
      dates: [],
      usuarios: [],
      search: "",
      tipoMovimiento: "",
      menuRango: false,
      rangoTexto: "",
      totalItems: 0,
      itemsPerPage: 10,
      page: 1,
      loading: false,
      dialog: false,
      editedIndex: -1,
      editedItem: {
        idRegistro: "",
        dispositivo: "",
        sede: "",
        activofijo: "",
        marca: "",
        cargo: "",
        nombreMovimiento: "",
        fechaMovimiento: "",
        movimiento: "",
      },
      defaultItem: {
        idRegistro: "",
        dispositivo: "",
        sede: "",
        activofijo: "",
        marca: "",
        cargo: "",
        nombreMovimiento: "",
        fechaMovimiento: "",
        movimiento: "",
      },
      permisosActivos: [],
      searchActivoFijo: "",
      loadingActivoFijo: false,
      permisoEstado: null,
      permisoMensaje: "",
      listaCargos: [],
      searchCargo: "",
      loadingCargos: false,
      snackbar: false,
      snackbarText: "",
    };
  },
  watch: {
    searchActivoFijo(val) {
      if (val && val.length > 0) {
        this.buscarActivosFijos(val);
      }
    },
    searchCargo(val) {
      if (val && val.length > 0) {
        this.buscarCargos(val);
      }
    },
  },
  async mounted() {
    await this.obtenerUsuarios();
    await this.obtenerTodo();
    await this.cargarPermisos();
    await this.obtenerCargos();
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Movimiento" : "Editar Movimiento";
    },
  },
  methods: {
    async onActivoFijoDesdeLista(item) {
  if (!item || typeof item !== "object") return;

  // SOLO permisos
  this.autocompletarDesdePermiso(item);
}
,
    async cargarPermisos() {
      this.loadingActivoFijo = true;
      try {
        const res = await axios.get(
          `${env.endpointEntradasSalidas}/permisos`
        );
        this.permisosActivos = res.data || [];
      } catch (error) {
        console.error("Error al cargar permisos:", error);
        this.permisosActivos = [];
      } finally {
        this.loadingActivoFijo = false;
      }
    },

    async obtenerCargos() {
      this.loadingCargos = true;
      try {
        const res = await axios.get(`${env.endpointEntradasSalidas}/cargos`);
        this.listaCargos = res.data.data || [];
      } catch (error) {
        console.error("Error al obtener cargos:", error);
        this.listaCargos = [];
      } finally {
        this.loadingCargos = false;
      }
    },

    async cargarActivos() {
      try {
        const res = await axios.get(`${env.endpointEntradasSalidas}/activos`);
        this.permisosActivos = res.data.data || [];
      } catch (e) {
        console.error("Error cargando activos:", e);
      }
    },

    async buscarActivosFijos(query) {
      this.loadingActivoFijo = true;
      try {
        const res = await axios.get(`${env.endpointEntradasSalidas}/permisos`);
        const todos = res.data || [];
        
        // Si no hay query, mostrar todos los resultados
        if (!query || query.trim() === "") {
          this.permisosActivos = todos;
        } else {
          // Si hay query, filtrar los resultados
          this.permisosActivos = todos.filter((p) =>
            p.activo_fijo?.toLowerCase().includes(query.toLowerCase())
          );
        }
      } catch (error) {
        console.error("Error al buscar activos:", error);
      } finally {
        this.loadingActivoFijo = false;
      }
    },

    async onActivoFijoChange(item) {
      // 1️⃣ SELECCIONADO DE LA LISTA (objeto)
      if (item && typeof item === "object") {
        this.autocompletarDesdePermiso(item);
        return;
      }
      

      // 2️⃣ ESCRITO MANUALMENTE (string)
      if (typeof item === "string" && item.trim() !== "") {
        this.editedItem.activofijo = item;

        try {
          const res = await axios.get(
            `${env.endpointEntradasSalidas}/permiso_por_activo/${item}`
          );

          if (res.data && Object.keys(res.data).length > 0) {
            this.autocompletarDesdePermiso(res.data);
          } else {
            this.limpiarAutocompletado();
          }
        } catch (e) {
          console.error("Error buscando permiso:", e);
          this.limpiarAutocompletado();
        }
      }
    },
    async onEnterActivoFijo() {
  const activo = this.editedItem.activofijo;

  if (!activo || typeof activo !== "string") return;

  try {
    const res = await axios.get(
      `${env.endpointEntradasSalidas}/userActivoFijo/${activo.trim()}`
    );

    if (res.data && Object.keys(res.data).length > 0) {
      this.autocompletarDesdeMovimiento(res.data);
    } else {
      this.limpiarAutocompletado();
    }
  } catch (e) {
    console.error("Error buscando movimiento:", e);
    this.limpiarAutocompletado();
  }
}
,
autocompletarDesdeMovimiento(data) {
  this.editedItem.activofijo = data.activofijo || "";
  this.editedItem.dispositivo = data.dispositivo || "";
  this.editedItem.marca = data.marca || "";
  this.editedItem.cargo = data.cargo || "";
  this.editedItem.nombreMovimiento = data.nombreMovimiento || "";

  this.permisoEstado = false;
  this.permisoMensaje = "Datos cargados desde movimientos anteriores.";
},
limpiarAutocompletado() {
  this.editedItem.dispositivo = "";
  this.editedItem.marca = "";
  this.editedItem.cargo = "";
  this.editedItem.nombreMovimiento = "";
  this.permisoEstado = null;
  this.permisoMensaje = "";
},

    autocompletarDesdePermiso(data) {
      // Manejar tanto activo_fijo (con guión) como activofijo (sin guión)
      this.editedItem.activofijo = data.activo_fijo || data.activofijo || "";
      this.editedItem.nombreMovimiento = data.nombre || data.nombreMovimiento || data.Cargo || data.Dispositivo ||data.marca || "";
      this.editedItem.dispositivo = data.dispositivo || "";
      this.editedItem.marca = data.marca || "";
      this.editedItem.cargo = data.cargo || "";

      if (data.permiso === "SI") {
        this.permisoEstado = true;
        this.permisoMensaje = "Activo fijo autorizado para salir.";
      } else {
        this.permisoEstado = false;
        this.permisoMensaje = "Activo fijo NO está autorizado para salir.";
      }
    },

    limpiarAutocompletado() {
      this.editedItem.dispositivo = "";
      this.editedItem.marca = "";
      this.editedItem.cargo = "";
      this.editedItem.nombreMovimiento = "";
      this.permisoEstado = null;
      this.permisoMensaje = "";
    },

    async buscarCargos(query) {
      this.loadingCargos = true;
      try {
        const res = await axios.get(`${env.endpointEntradasSalidas}/cargos`, {
          params: { search: query || "" },
        });
        this.listaCargos = res.data.data || [];
      } catch (error) {
        console.error("Error al buscar cargos:", error);
        this.listaCargos = [];
      } finally {
        this.loadingCargos = false;
      }
    },

    onDatesInput(val) {
      this.dates = val;

      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        let inicio = val[0];
        let fin = val[1];
        if (inicio > fin) {
          [inicio, fin] = [fin, inicio];
        }

        this.rangoTexto = `${inicio} - ${fin}`;
        this.menuRango = false;
        this.page = 1;
        this.obtenerTodo();
      }
    },

    aplicarFiltros() {
      this.page = 1;
      this.obtenerTodo();
    },

    limpiarFiltros() {
      this.dates = [];
      this.rangoTexto = "";
      this.tipoMovimiento = "";
      this.search = "";
      this.page = 1;
      this.obtenerTodo();
    },

    async obtenerTodo() {
      this.loading = true;
      try {
        const params = {};

        if (Array.isArray(this.dates) && this.dates.length === 2) {
          params.fechaInicio = this.dates[0];
          params.fechaFin = this.dates[1];
        }

        if (this.tipoMovimiento) params.movimiento = this.tipoMovimiento;
        if (this.search.trim() !== "") params.search = this.search.trim();

        const res = await axios.get(
          `${env.endpointEntradasSalidas}/registros`,
          { params }
        );
        this.areas = res.data;
        this.totalItems = this.areas.length;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async obtenerUsuarios() {
      try {
        const res = await axios.get(`${env.endpointEntradasSalidas}/usuarios`);
        this.usuarios = res.data;
      } catch (e) {
        console.error("Error cargando usuarios:", e);
      }
    },

    close() {
      this.dialog = false;
      this.permisoEstado = null;
      this.permisoMensaje = "";
      this.buscarActivosFijos();
      this.buscarCargos();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    resetForm() {
      this.permisoEstado = null;
      this.permisoMensaje = "";
      this.editedItem = {
        movimiento: "",
        activofijo: "",
        dispositivo: "",
        marca: "",
        cargo: "",
        nombreMovimiento: "",
      };
    },

    editItem(item) {
      this.editedIndex = this.areas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    save() {
     const cargoValue =
    typeof this.editedItem.cargo === "object" && this.editedItem.cargo !== null
      ? this.editedItem.cargo.nombreCargo
      : this.editedItem.cargo;

  // ===============================
  // 2️⃣ Procesar ACTIVO FIJO
  // ===============================
  let activoFijoValue = "";

  if (this.editedItem.activofijo) {
    if (
      typeof this.editedItem.activofijo === "object" &&
      this.editedItem.activofijo !== null
    ) {
      activoFijoValue =
        this.editedItem.activofijo.activo_fijo ||
        this.editedItem.activofijo.activofijo ||
        "";
    } else {
      activoFijoValue = this.editedItem.activofijo;
    }
  }

  // ===============================
  // 3️⃣ Validación
  // ===============================
  if (!activoFijoValue.trim()) {
    this.snackbar = true;
    this.snackbarText = "El campo Activo Fijo es obligatorio";
    return;
  }

  // ===============================
  // 4️⃣ Payload base
  // ===============================
  const payload = {
    activofijo: activoFijoValue,
    dispositivo: this.editedItem.dispositivo,
    marca: this.editedItem.marca,
    cargo: cargoValue,
    nombreMovimiento: this.editedItem.nombreMovimiento,
    movimiento: this.editedItem.movimiento,
    sede: this.editedItem.sede,
  };

  // ===============================
  // 5️⃣ Detectar edición
  // ===============================
  const esEdicion = !!this.editedItem.idRegistro;

  let request;

  if (esEdicion) {
    // 🔄 ACTUALIZAR
    payload.idRegistro = this.editedItem.idRegistro;

    const params = new URLSearchParams();
    Object.keys(payload).forEach((key) => {
      params.append(key, payload[key] ?? "");
    });

    request = axios.put(
      `${env.endpointEntradasSalidas}/movimientos/${this.editedItem.idRegistro}`,
      params,
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );
  } else {
    // ➕ CREAR
    payload.idVigilante = localStorage.getItem("id");

    const json = JSON.stringify(payload);

    request = axios.get(
      `${env.endpointEntradasSalidas}/create_movimiento?movimiento=${encodeURIComponent(
        json
      )}`
    );
  }

  // ===============================
  // 6️⃣ Respuesta única
  // ===============================
  request
    .then((res) => {
      this.snackbar = true;
      this.snackbarText = esEdicion
        ? "Movimiento actualizado satisfactoriamente"
        : "Movimiento registrado satisfactoriamente";

      this.obtenerTodo();
      this.close();
    })
    .catch((error) => {
      console.error("Error guardando movimiento:", error);
      this.snackbar = true;
      this.snackbarText = "Error al guardar el movimiento";
    })
    .finally(() => {
      this.permisoEstado = null;
      this.permisoMensaje = "";
    });
  },

    downloadExcel() {
      if (!this.areas.length) return;

      const data = this.areas.map((item) => ({
        Sede: item.sede,
        Dispositivo: item.dispositivo,
        Fecha: item.fechaMovimiento,
        ActivoFijo: item.activofijo || item.serial,
        Responsable: item.nombreMovimiento,
        Cargo: item.cargo || item.modelo,
        Vigilante: item.vigilante_nombre || item.idVigilante,
        Movimiento: item.movimiento,
      }));

      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Registros");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const dataBlob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(dataBlob, "Historial_Movimientos.xlsx");
    },

    guardarFechas() {
      console.log("guardarFechas ejecutado");
      // aquí va la lógica real
    },
  },
};
</script>

<style scoped>
.hover-row:hover {
  background-color: #f9fafb !important;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.edit-btn:hover {
  background-color: #1e3a8a !important;
  color: white !important;
}

.edit-btn:hover .v-icon {
  color: white !important;
}
</style>